import React, { useEffect, useState } from "react";
// material
import { Grid, Container, CardHeader, CardContent } from "@mui/material";
import { useSelector } from "react-redux";
import { getProgressReportApprovalListAdmin } from "../core/service/progressReport.service";

// components
import Page from "../components/Page";
import {
  ProgressReportApprovalAdminTable,
  ConfirmationOutputSubmissionAdminTable
} from "../components/_dashboard/app";
import { getOutputSubmissionAdmin } from "../core/service/outputSubmission.service";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function ProgressReportApprovalAdmin() {
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const [listApprovalAdmin, setListApprovalAdmin] = useState([{}]);
  const { entities } = listApprovalAdmin;

  const [listOutputSubmission, setListOutputSubmission] = useState([{}]);
  const entities_out = listOutputSubmission.entities;

  const outputSubmissionList = async () => {
    const data = await getOutputSubmissionAdmin();
    setListOutputSubmission(data);
  };

  useEffect(() => {
    const progressReportApprovalListAdmin = async () => {
      const data = await getProgressReportApprovalListAdmin();
      setListApprovalAdmin(data);
    };

    progressReportApprovalListAdmin();
    outputSubmissionList();
  }, []);

  return (
    <Page title="Progress Report Approval">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <ProgressReportApprovalAdminTable listApprove={entities || []} />
          </Grid>

          <Grid item xs={12} md={6} lg={12} sx={{ marginTop: 5 }}>
            <ConfirmationOutputSubmissionAdminTable
              listOutput={entities_out || []}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
